import React from 'react';
import { Link } from 'react-router-dom';
import { ScrollText } from 'lucide-react';
import BreadcrumbNav from '../components/common/BreadcrumbNav';
import SEOHead from '../components/common/SEOHead';
import { BRAND_FULL_NAME, BRAND_NAME } from '../config/brand';

const TermsOfService: React.FC = () => {
  const breadcrumbs = [{ name: 'الشروط والأحكام', path: '/terms' }];

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <SEOHead
        title={`الشروط والأحكام | ${BRAND_NAME}`}
        description={`شروط وأحكام استخدام منصة أوائل مصر — حسابات الطلاب، الاشتراكات، والمحتوى التعليمي.`}
        keywords={`شروط الاستخدام, أحكام أوائل مصر, اشتراك كورسات`}
        url="/terms"
        breadcrumbs={breadcrumbs}
      />

      <div className="border-b bg-white shadow-sm">
        <div className="mx-auto max-w-4xl px-4 py-6 sm:px-6 lg:px-8">
          <BreadcrumbNav items={breadcrumbs} />
          <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900 sm:text-3xl">
            <ScrollText className="h-7 w-7 text-green-700" />
            الشروط والأحكام
          </h1>
        </div>
      </div>

      <article className="mx-auto max-w-4xl space-y-8 px-4 py-8 text-sm leading-relaxed text-gray-700 sm:px-6 sm:text-base lg:px-8">
        <p>
          باستخدامك لـ {BRAND_FULL_NAME} فإنك توافق على هذه الشروط. المنصة تقدّم محتوى تعليمياً أونلاين
          لطلاب كل المراحل الدراسية.
        </p>

        <section>
          <h2 className="mb-3 text-xl font-bold text-green-900">1. الحساب والمسؤولية</h2>
          <ul className="list-disc space-y-2 pe-5">
            <li>يجب إدخال بيانات صحيحة عند التسجيل والحفاظ على سرية كلمة المرور.</li>
            <li>الحساب شخصي؛ يُحظر مشاركة بيانات الدخول أو إعادة بيع الاشتراك.</li>
            <li>ولي الأمر مسؤول عن متابعة استخدام القُصّر للمنصة.</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-bold text-green-900">2. المحتوى والاشتراكات</h2>
          <ul className="list-disc space-y-2 pe-5">
            <li>المحتوى محمي بحقوق ملكية؛ الاستخدام للدراسة الشخصية فقط.</li>
            <li>يُحظر نسخ أو تسجيل أو توزيع الفيديوهات والمواد خارج المنصة.</li>
            <li>مدة الوصول للكورس وفق ما يُعرض عند الشراء ما لم يُنص على خلاف ذلك.</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-bold text-green-900">3. المدفوعات والاسترجاع</h2>
          <p>
            تخضع عمليات الدفع والاسترجاع لصفحة{' '}
            <Link to="/refund-policy" className="font-semibold text-green-800 underline">
              سياسة الاسترجاع
            </Link>
            . المنتجات رقمية وتُفعَّل فور إتمام الشراء أو إدخال الكود الصحيح.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-bold text-green-900">4. السلوك المقبول</h2>
          <p>
            يُحظر إساءة استخدام المنتدى أو التواصل، أو محاولة اختراق المنصة، أو تعطيل الخدمة. نحتفظ
            بحق تعليق الحساب عند المخالفة.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-bold text-green-900">5. إخلاء المسؤولية</h2>
          <p>
            نبذل جهداً لتقديم محتوى دقيق، لكن النتائج الدراسية تعتمد على جهد الطالب. المنصة لا تضمن
            درجة أو نتيجة امتحان معينة. قد يحدث انقطاع مؤقت للصيانة أو ظروف خارجة عن الإرادة.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-bold text-green-900">6. القانون والتواصل</h2>
          <p>
            تُفسَّر هذه الشروط وفق القوانين المعمول بها في جمهورية مصر العربية. للاستفسارات راجع{' '}
            <Link to="/contact" className="font-semibold text-green-800 underline">
              تواصل معنا
            </Link>{' '}
            أو{' '}
            <Link to="/privacy" className="font-semibold text-green-800 underline">
              سياسة الخصوصية
            </Link>
            .
          </p>
        </section>

        <p className="border-t border-gray-200 pt-6 text-sm text-gray-500">آخر تحديث: يوليو 2026</p>
      </article>
    </div>
  );
};

export default TermsOfService;
